import { UtilMasks } from 'src/app/utils/util-masks';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CiacService } from 'src/app/services/http/ciac.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-form-fornecedores-ciac',
  templateUrl: './form-fornecedores-ciac.component.html',
  styleUrls: ['./form-fornecedores-ciac.component.scss']
})
export class FormFornecedoresCiacComponent implements OnInit {

  sorting: { 
    id: "asc",
    nome: "",
  }

  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    cnpj: new FormControl('', [Validators.required]),
    url: new FormControl(''),
    urldocumentacao: new FormControl('')
  });

  masks = {
    placa: {mask: UtilMasks.placa, guide: false},
    cnpj: {mask: UtilMasks.cnpj, guide: false},
  };

  id;
  listaFornecedores = [];
  retornoPromisse;

  constructor(private activatedRoute: ActivatedRoute, private ciacService: CiacService, private router: Router, private modal: ModalMsgService) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id || null;
    if(this.id) {
      this.ciacService.getFornecedor(this.id).then(c => {
        this.form.patchValue(c);
      });
    }
  }

  submitForm() {
    if(this.id) {
      let params = {
        id: parseInt(this.id),
        nome: this.form.controls.nome.value,
        cnpj: this.form.controls.cnpj.value,
        url: this.form.controls.url.value,
        urlDocumentacao: this.form.controls.urldocumentacao.value,
      }
      this.ciacService.updateFornecedorCiac(params).then(c => {
        if(c.success) {
          this.router.navigate(['ciac', 'fornecedores', 'listar']);
        }else {
          this.modal.openDialog(
            'Erro ao cadastrar Fornecedor',
            'Por favor, verifique os campos.',
            'danger'
          );
          return;
        }
      });
    }else {
      let params = {
        nome: this.form.controls.nome.value,
        cnpj: this.form.controls.cnpj.value,
        url: this.form.controls.url.value,
        urlDocumentacao: this.form.controls.urldocumentacao.value,
      }
      this.ciacService.addFornecedorCiac(params).then(c => {
        if(c.success) {
          this.router.navigate(['ciac', 'fornecedores', 'listar']);
        }else if(c.message === "Este CNPJ já esta cadastrado") {
          this.modal.openDialog(
            'Erro ao cadastrar fornecedor',
            'CNPJ já cadastrado, por favor, insira um novo CNPJ.',
            'danger'
          );
          return;
        }else {
          this.modal.openDialog(
            'Erro ao cadastrar Fornecedor',
            'Por favor, verifique os campos.',
            'danger'
          );
          return;
        }
      });
    }
  }

}
